import axios from "axios";
import { headersTokenConfig } from "../config/HeaderToken";
import { headersTokenExcel } from "../config/HeaderTokenExcel";

class Report {
  consumer(page, limit, search, startDate, endDate) {
    const endPoint = `/report/deposit/consumer?start=${startDate}&end=${endDate}&page=${page}&limit=${limit}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    if (search) {
      url = process.env.REACT_APP_API_URL_V1 + endPoint + `&search=${search}`;
    }

    return axios.get(url, headersTokenConfig);
  }

  consumerExcel(startDate, endDate) {
    const endPoint = `/report/deposit/consumer/excel?start=${startDate}&end=${endDate}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    return axios.get(url, headersTokenExcel);
  }

  consumerInvoice(projectId) {
    const endPoint = `/report/deposit/invoice?project_id=${projectId}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    return axios.get(url, headersTokenConfig);
  }

  consumerMultipleInvoice(payload) {
    const url = process.env.REACT_APP_API_URL_V1 + `/report/deposit/invoice-multiple`;
    return axios.post(url, payload, headersTokenConfig);
  }

  vendor(page, limit, search, startDate, endDate, stage, group) {
    const endPoint = `/report/deposit/vendor?start=${startDate}&end=${endDate}&page=${page}&limit=${limit}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }

    if (stage) {
      url += `&stage=${stage}`;
    }

    if (group) {
      url += `&group=${group}`;
    }

    return axios.get(url, headersTokenConfig);
  }

  vendorExcel(startDate, endDate, stage, group) {
    const endPoint = `/report/deposit/vendor/excel?start=${startDate}&end=${endDate}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    if (stage) {
      url += `&stage=${stage}`;
    }

    if (group) {
      url += `&group=${group}`;
    }

    return axios.get(url, headersTokenExcel);
  }

  // Semua sub menu tab Vendor dalam satu file, satu sheet per sub menu
  vendorExcelAll(startDate, endDate) {
    const endPoint = `/report/deposit/vendor/excel-all?start=${startDate}&end=${endDate}`;
    const url = process.env.REACT_APP_API_URL_V1 + endPoint;

    return axios.get(url, headersTokenExcel);
  }

  contractor(page, limit, search, startDate, endDate) {
    const endPoint = `/report/deposit/contractor?start=${startDate}&end=${endDate}&page=${page}&limit=${limit}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    if (search) {
      url = process.env.REACT_APP_API_URL_V1 + endPoint + `&search=${search}`;
    }

    return axios.get(url, headersTokenConfig);
  }

  contractorExcel(startDate, endDate) {
    const endPoint = `/report/deposit/contractor/excel?start=${startDate}&end=${endDate}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    return axios.get(url, headersTokenExcel);
  }

  pelaksana(page, limit, search, startDate, endDate) {
    const endPoint = `/report/deposit/pelaksana?start=${startDate}&end=${endDate}&page=${page}&limit=${limit}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    if (search) {
      url = process.env.REACT_APP_API_URL_V1 + endPoint + `&search=${search}`;
    }

    return axios.get(url, headersTokenConfig);
  }

  pelaksanaExcel(startDate, endDate) {
    const endPoint = `/report/deposit/pelaksana/excel?start=${startDate}&end=${endDate}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    return axios.get(url, headersTokenExcel);
  }

  voucher(page, limit, search, startDate, endDate) {
    const endPoint = `/report/deposit/consumer/voucher?start=${startDate}&end=${endDate}&page=${page}&limit=${limit}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    if (search) {
      url = process.env.REACT_APP_API_URL_V1 + endPoint + `&search=${search}`;
    }

    return axios.get(url, headersTokenConfig);
  }

  voucherExcel(startDate, endDate) {
    const endPoint = `/report/deposit/consumer/voucher/excel?start=${startDate}&end=${endDate}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    return axios.get(url, headersTokenExcel);
  }

  komisiVendors(startDate, endDate, search) {
    const endPoint = `/report/deposit/consumer/voucher/rekap?start=${startDate}&end=${endDate}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    if (search) {
      url = process.env.REACT_APP_API_URL_V1 + endPoint + `&search=${search}`;
    }

    return axios.get(url, headersTokenExcel);
  }

  komisiVendorsExcel(startDate, endDate) {
    const endPoint = `/report/deposit/consumer/voucher/rekap/excel?start=${startDate}&end=${endDate}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    return axios.get(url, headersTokenExcel);
  }

  salaryCalculation(page, limit, search, startDate, endDate, sort_by, sort_type, source_project, sesi) {
    const params = {
      start_date: startDate,
      end_date: endDate,
      page: page,
      limit: limit,
    };

    if (sort_by) {
      params.sort_by = sort_by;
    }

    if (sort_type) {
      params.sort_type = sort_type;
    }

    if (source_project) {
      params.source_project = source_project;
    }

    if (sesi) {
      params.sesi = sesi;
    }

    let baseUrl = process.env.REACT_APP_API_URL_V2;
    let endPoint = `/report/salary?` + new URLSearchParams(params).toString();

    if (search) {
      baseUrl = process.env.REACT_APP_API_URL_V2;
      endPoint += `&search=${search}`;
    }

    const url = `${baseUrl}${endPoint}`;
    return axios.get(url, headersTokenConfig);
  }

  salaryCalculationExcel(payload) {
    const endPoint = `/report/upah-tukang/excel?start=${payload.start_date}&end=${payload.end_date}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    return axios.get(url, headersTokenExcel);
  }

  salaryCalculationExcelByPm(startDate, endDate) {
    const endPoint = `/report/upah-tukang/excel/pm?start=${startDate}&end=${endDate}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    return axios.get(url, headersTokenExcel);
  }

  salaryCalculationMitra10(page, limit, search, startDate, endDate) {
    const endPoint = `/report/upah-tukang/mitra10?start=${startDate}&end=${endDate}&page=${page}&limit=${limit}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    if (search) {
      url = process.env.REACT_APP_API_URL_V1 + endPoint + `&search=${search}`;
    }

    return axios.get(url, headersTokenConfig);
  }

  salaryCalculationMitra10Excel(startDate, endDate) {
    const endPoint = `/report/upah-tukang/mitra10/excel?start=${startDate}&end=${endDate}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    return axios.get(url, headersTokenExcel);
  }

  disbursmentWorker(page, limit, search, startDate, endDate) {
    const endPoint = `/report/disbursment-worker?start=${startDate}&end=${endDate}&page=${page}&limit=${limit}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    if (search) {
      url = process.env.REACT_APP_API_URL_V1 + endPoint + `&search=${search}`;
    }

    return axios.get(url, headersTokenConfig);
  }

  disbursmentWorkerExcel(startDate, endDate) {
    const endPoint = `/report/disbursment-worker/excel?start=${startDate}&end=${endDate}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    return axios.get(url, headersTokenExcel);
  }

  disbursmentWorkerNew(page, limit, search, startDate, endDate) {
    const endPoint = `/report/salary/disbursement?start_date=${startDate}&end_date=${endDate}&page=${page}&limit=${limit}`;
    let url = process.env.REACT_APP_API_URL_V2 + endPoint;

    if (search) {
      url = process.env.REACT_APP_API_URL_V2 + endPoint + `&search=${search}`;
    }

    return axios.get(url, headersTokenConfig);
  }

  disbursmentWorkerExcelNew(payload) {
    const endPoint = `/report/salary/disbursement/export`;
    let url = process.env.REACT_APP_API_URL_V2 + endPoint;

    return axios.post(url, payload, headersTokenExcel);
  }

  disbursmentWorkerExcelDetailNew(startDate, endDate) {
    const endPoint = `/report/disbursment-worker-new/excel-detail?start=${startDate}&end=${endDate}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    return axios.get(url, headersTokenExcel);
  }

  disbursmentWorkerMitra10(page, limit, search, startDate, endDate) {
    const endPoint = `/report/disbursment-worker/mitra10?start=${startDate}&end=${endDate}&page=${page}&limit=${limit}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    if (search) {
      url = process.env.REACT_APP_API_URL_V1 + endPoint + `&search=${search}`;
    }

    return axios.get(url, headersTokenConfig);
  }

  disbursmentWorkerMitra10Excel(startDate, endDate) {
    const endPoint = `/report/disbursment-worker/mitra10/excel?start=${startDate}&end=${endDate}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    return axios.get(url, headersTokenExcel);
  }

  refundKontraktor(page, limit, search, startDate, endDate) {
    const endPoint = `/report/refund-kontraktor?start=${startDate}&end=${endDate}&page=${page}&limit=${limit}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    if (search) {
      url = process.env.REACT_APP_API_URL_V1 + endPoint + `&search=${search}`;
    }

    return axios.get(url, headersTokenConfig);
  }

  refundKontraktorExcel(startDate, endDate) {
    const endPoint = `/report/refund-kontraktor/excel?start=${startDate}&end=${endDate}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    return axios.get(url, headersTokenExcel);
  }

  bonusPoint(page, limit, search, startDate, endDate) {
    const endPoint = `/report/bonus-point?start=${startDate}&end=${endDate}&page=${page}&limit=${limit}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    if (search) {
      url = process.env.REACT_APP_API_URL_V1 + endPoint + `&search=${search}`;
    }

    return axios.get(url, headersTokenConfig);
  }

  bonusPointExcel(startDate, endDate) {
    const endPoint = `/report/bonus-point/excel?start=${startDate}&end=${endDate}`;
    let url = process.env.REACT_APP_API_URL_V1 + endPoint;

    return axios.get(url, headersTokenExcel);
  }
}

export default new Report();
